(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function initDropdownMenuHover() {
      var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

      // Top-level menu (link.links)
      document.querySelectorAll('header-menu').forEach(function (headerMenu) {
        var details = headerMenu.querySelector('details');
        var summary = headerMenu.querySelector(':scope > details > summary');
        if (!details || !summary) return;

        var closeTimer;

        headerMenu.addEventListener('mouseenter', function () {
          if (!hoverCapable.matches) return;
          clearTimeout(closeTimer);

          document.querySelectorAll('header-menu details[open]').forEach(function (openDetails) {
            if (openDetails !== details) openDetails.removeAttribute('open');
          });

          details.setAttribute('open', '');
        });

        headerMenu.addEventListener('mouseleave', function () {
          if (!hoverCapable.matches) return;
          closeTimer = setTimeout(function () {
            details.removeAttribute('open');
            // Also collapse any nested submenu left open inside
            details.querySelectorAll('details[open]').forEach(function (nested) {
              nested.removeAttribute('open');
            });
          }, 150);
        });

        summary.addEventListener('click', function (event) {
          // event.detail === 0 means it was triggered by keyboard (Enter/Space), not a real mouse click
          if (hoverCapable.matches && event.detail !== 0) {
            event.preventDefault();
          }
        });
      });

      // Nested submenu (childlink.links, i.e. grandchildlinks)
      document.querySelectorAll('details[id^="Details-HeaderSubMenu-"]').forEach(function (details) {
        var summary = details.querySelector('summary');
        if (!summary) return;

        var closeTimer;

        details.addEventListener('mouseenter', function () {
          if (!hoverCapable.matches) return;
          clearTimeout(closeTimer);
          details.setAttribute('open', '');
        });

        details.addEventListener('mouseleave', function () {
          if (!hoverCapable.matches) return;
          closeTimer = setTimeout(function () {
            details.removeAttribute('open');
          }, 150);
        });

        summary.addEventListener('click', function (event) {
          if (hoverCapable.matches && event.detail !== 0) {
            event.preventDefault();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDropdownMenuHover);
    } else {
      initDropdownMenuHover();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMegaMenuHover() {
      var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

      document.querySelectorAll('header-menu').forEach(function (headerMenu) {
        var details = headerMenu.querySelector('details.mega-menu');
        var summary = headerMenu.querySelector('summary');
        if (!details || !summary) return;

        var closeTimer;

        headerMenu.addEventListener('mouseenter', function () {
          if (!hoverCapable.matches) return;
          clearTimeout(closeTimer);

          document.querySelectorAll('header-menu details.mega-menu[open]').forEach(function (openDetails) {
            if (openDetails !== details) openDetails.removeAttribute('open');
          });

          details.setAttribute('open', '');
        });

        headerMenu.addEventListener('mouseleave', function () {
          if (!hoverCapable.matches) return;
          closeTimer = setTimeout(function () {
            details.removeAttribute('open');
          }, 150);
        });

        summary.addEventListener('click', function (event) {
          // event.detail === 0 means it was triggered by keyboard (Enter/Space), not a real mouse click
          if (hoverCapable.matches && event.detail !== 0) {
            event.preventDefault();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMegaMenuHover);
    } else {
      initMegaMenuHover();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
